// - Central registry for landing article pages and metadata
// - Powers slug-based routing helpers for the articles experience
// - Keeps article component imports organized for automated updates
import ArticleContent0, { metadata as metadata0 } from './ai-sports-betting-analysis-draftkings-fanduel.jsx';
import ArticleContent1, { metadata as metadata1 } from './prediction-markets-sports-betting-kalshi-polymarket.jsx';
import ArticleContent2, { metadata as metadata2 } from './nfl-betting-strategy-ai-analysis.jsx';
import ArticleContent3, { metadata as metadata3 } from './ncaa-football-betting-college-football-strategy.jsx';
import ArticleContent4, { metadata as metadata4 } from './nba-betting-strategy-basketball-analysis.jsx';
import ArticleContent5, { metadata as metadata5 } from './mlb-betting-baseball-strategy-ai.jsx';
import ArticleContent6, { metadata as metadata6 } from './sports-betting-bankroll-management.jsx';
import ArticleContent7, { metadata as metadata7 } from './parlay-betting-strategy-same-game-parlays.jsx';
import ArticleContent8, { metadata as metadata8 } from './live-betting-in-game-wagering-strategy.jsx';
import ArticleContent9, { metadata as metadata9 } from './prediction-markets-revolution-fanduel-sports-betting-strategy.jsx';
import ArticleContent10, { metadata as metadata10 } from './2025-sports-betting-revolution-nba-global-markets.jsx';
import ArticleContent11, { metadata as metadata11 } from './nba-trade-deadline-shockwave-doncic-durant-butler.jsx';
import ArticleContent12, { metadata as metadata12 } from './dodgers-dynasty-back-to-back-world-series-titles-game-7-comeback.jsx';
import ArticleContent13, { metadata as metadata13 } from './nfl-18-game-season-burrow-return-betting-playoffs.jsx';
import ArticleContent14, { metadata as metadata14 } from './nba-mvp-race-heats-up-giannis-tatum-sga.jsx';
import ArticleContent15, { metadata as metadata15 } from './lebron-historic-playoff-surge-herbert-injury-shockwave.jsx';
import ArticleContent16, { metadata as metadata16 } from './nfl-18-game-season-player-equity-rest-disparity.jsx';
import ArticleContent17, { metadata as metadata17 } from './sports-world-shaken-ohatani-free-agency-cfb-playoff-chaos-nba-coaching-drama.jsx';
import ArticleContent18, { metadata as metadata18 } from './mlb-expansion-duke-upset-nfl-injuries-ai-betting-analysis.jsx';
import ArticleContent19, { metadata as metadata19 } from './nfl-betting-trends-2025-lions-road-magic-home-favorites-dominance.jsx';
import ArticleContent20, { metadata as metadata20 } from './nbas-youngest-triple-double-star-emerges-pitchmetrics-ai-anticipated-market-shifts.jsx';
import ArticleContent21, { metadata as metadata21 } from './nba-luka-injury-michigan-ncaa-sanctions-pitchmetric.jsx';
import ArticleContent22, { metadata as metadata22 } from './nba-coaching-carousel-2025-betting-implications.jsx';
import ArticleContent23, { metadata as metadata23 } from './nba-scoring-surge-bucks-lakers-edwards-nuggets.jsx';
import ArticleContent24, { metadata as metadata24 } from './nuggets-t-wolves-rest-edge-ai-market-shift.jsx';
import ArticleContent25, { metadata as metadata25 } from './nba-betting-trends-thunder-road-favorites.jsx';
import ArticleContent26, { metadata as metadata26 } from './lakers-defense-meltdown-nba-scoring-surge-pitchmetric-ai-betting-edges.jsx';
import ArticleContent27, { metadata as metadata27 } from './cavaliers-95-public-support-grizzlies-skid-ai-nba-betting.jsx';
import ArticleContent28, { metadata as metadata28 } from './ravens-chiefs-upset-ai-predicts-jacksons-heroics.jsx';
import ArticleContent29, { metadata as metadata29 } from './nfl-playoff-shakeup-patriots-afc-top-seed-49ers-purdy-injury.jsx';
import ArticleContent30, { metadata as metadata30 } from './nfl-playoff-picture-shakes-up-burrows-return-broncos-shock-eagles-reign.jsx';
import ArticleContent31, { metadata as metadata31 } from './seahawks-ram-ot-miracle-nfc-wild-card-colts-afc-implications.jsx';
import ArticleContent32, { metadata as metadata32 } from './nfl-shakeup-josh-allen-injury-giants-coaching-change.jsx';
import ArticleContent33, { metadata as metadata33 } from './nfl-playoff-race-bears-surge-chiefs-stumble-injuries-reshape-odds.jsx';
import ArticleContent34, { metadata as metadata34 } from './chargers-late-season-surge-shakes-up-afc-playoff-race.jsx';
import ArticleContent35, { metadata as metadata35 } from './nfl-playoff-race-seahawks-colts-overtime-wins-injuries-shake-standings.jsx';
import ArticleContent36, { metadata as metadata36 } from './afc-playoff-race-shakeup-texans-surpass-chiefs-injuries-suspensions.jsx';
import ArticleContent37, { metadata as metadata37 } from './afc-playoff-race-broncos-surge-chase-suspension-2025.jsx';
import ArticleContent38, { metadata as metadata38 } from './nfl-playoff-chaos-patriots-clinch-chase-suspension-penix-injury.jsx';
import ArticleContent39, { metadata as metadata39 } from './afc-playoff-race-chargers-chase-suspension.jsx';
import ArticleContent40, { metadata as metadata40 } from './nfc-playoff-race-intensifies-eagles-rams-bears-bucs-pitchmetric-edge.jsx';
import ArticleContent41, { metadata as metadata41 } from './nfl-playoff-picture-broncos-upset-bears-surge-seahawks-fall-2025.jsx';
import ArticleContent42, { metadata as metadata42 } from './playoff-drama-rihardson-chase-patriots.jsx';
import ArticleContent43, { metadata as metadata43 } from './nfl-playoff-drama-steelers-comeback-seahawks-setback.jsx';
import ArticleContent44, { metadata as metadata44 } from './nfl-playoff-chaos-burrows-injury-chiefs-collapse-bears-rise.jsx';
import ArticleContent45, { metadata as metadata45 } from './nfl-playoff-race-chaos-bears-rise-stroud-injury-broncos-upset.jsx';
import ArticleContent46, { metadata as metadata46 } from './afc-playoff-race-week-11-colts-broncos-patriots.jsx';
import ArticleContent47, { metadata as metadata47 } from './nfc-playoff-gauntlet-packers-panthers-hard-road.jsx';
import ArticleContent48, { metadata as metadata48 } from './nfl-playoff-race-upended-seahawks-steelers-surge.jsx';
import ArticleContent49, { metadata as metadata49 } from './nfl-playoff-race-eagles-rams-afc-upsets.jsx';
import ArticleContent50, { metadata as metadata50 } from './bryce-young-panthers-nfc-playoff-race.jsx';
import ArticleContent51, { metadata as metadata51 } from './afc-playoff-patriots-broncos-showdown.jsx';
import ArticleContent52, { metadata as metadata52 } from './bears-nfc-north-lead-playoff-picture-2025.jsx';
import ArticleContent53, { metadata as metadata53 } from './cowboys-eagles-comeback-nfc-playoff-race-pitchmetric.jsx';
import ArticleContent54, { metadata as metadata54 } from './matthew-stafford-mvp-rams-nfc-dominance.jsx';
import ArticleContent55, { metadata as metadata55 } from './joe-burrow-bengals-ravens-thanksgiving-nfl-playoffs.jsx';
import ArticleContent56, { metadata as metadata56 } from './jordan-love-packers-lions-thanksgiving-upset.jsx';
import ArticleContent57, { metadata as metadata57 } from './cowboys-chiefs-thanksgiving-upset-afc-playoff-picture.jsx';
import ArticleContent58, { metadata as metadata58 } from './steph-curry-michael-jordan-45-point-streak-betting-edge.jsx';
import ArticleContent59, { metadata as metadata59 } from './bears-black-friday-upset-williams-rushing-duo-playoff-hopes.jsx';
import ArticleContent60, { metadata as metadata60 } from './nba-cup-quarterfinals-lakers-betting-analytics.jsx';
import ArticleContent61, { metadata as metadata61 } from './cooper-flagg-historic-game-ai-basketball-analytics.jsx';
import ArticleContent62, { metadata as metadata62 } from './okc-thunder-20-1-start-nba-betting-ai-analysis.jsx';
import ArticleContent63, { metadata as metadata63 } from './ryan-nembhard-nba-historic-game-ai-prediction.jsx';
import ArticleContent64, { metadata as metadata64 } from './giannis-antetokounmpo-trade-rumors-nba-betting-impact.jsx';
import ArticleContent65, { metadata as metadata65 } from './aj-griffin-jr-nba-retirement-ministry.jsx';
import ArticleContent66, { metadata as metadata66 } from './giannis-antetokounmpo-bucks-trade-talks-nba-future.jsx';
import ArticleContent67, { metadata as metadata67 } from './lebron-scoring-streak-ends-lakers-depth-emerges.jsx';
import ArticleContent68, { metadata as metadata68 } from './lebron-james-lakers-76ers-playoff-contenders-pitchmetric.jsx';
import ArticleContent69, { metadata as metadata69 } from './dodgers-superteam-mlb-betting-edge.jsx';
import ArticleContent70, { metadata as metadata70 } from './mets-juan-soto-record-deal-betting-impact.jsx';
import ArticleContent71, { metadata as metadata71 } from './mahomes-chiefs-ravens-afc-playoff-betting-analysis.jsx';
import ArticleContent72, { metadata as metadata72 } from './utah-football-whittingham-scalley-big12-transition.jsx';
import ArticleContent73, { metadata as metadata73 } from './falcons-bucs-nfc-south-playoff-race-tnf.jsx';
import ArticleContent74, { metadata as metadata74 } from './caleb-williams-bears-nfc-north-playoff-surge.jsx';
import ArticleContent75, { metadata as metadata75 } from './mahomes-injury-chiefs-dynasty-end-pitchmetric-analysis.jsx';
import ArticleContent76, { metadata as metadata76 } from './nfl-week-16-playoff-clinching-scenarios-pitchmetric.jsx';
import ArticleContent77, { metadata as metadata77 } from './broncos-chiefs-playoff-shift-pitchmetric-analysis.jsx';
import ArticleContent78, { metadata as metadata78 } from './ravens-derrick-henry-benching-playoff-impact.jsx';
import ArticleContent79, { metadata as metadata79 } from './nfl-week-17-playoff-chaos-ai-prediction.jsx';
import ArticleContent80, { metadata as metadata80 } from './vikings-lions-christmas-defensive-upset-2025.jsx';
import ArticleContent81, { metadata as metadata81 } from './drake-maye-injury-afc-playoff-race-pitchmetric.jsx';
import ArticleContent82, { metadata as metadata82 } from './broncos-chiefs-afc-playoff-picture-week-17.jsx';
import ArticleContent83, { metadata as metadata83 } from './patriots-afc-1-seed-drake-maye-super-bowl-2025.jsx';
import ArticleContent84, { metadata as metadata84 } from './lamar-jackson-return-ravens-steelers-playoff-showdown.jsx';
import ArticleContent85, { metadata as metadata85 } from './nfl-playoff-shakeup-broncos-patriots-rise-chiefs-bengals-fall.jsx';
import ArticleContent86, { metadata as metadata86 } from './bears-eagles-nfc-showdown-week-18.jsx';
import ArticleContent87, { metadata as metadata87 } from './ravens-fire-john-harbaugh-betting-fallout.jsx';
import ArticleContent88, { metadata as metadata88 } from './49ers-eagles-upset-pitchmetric-ai-prediction.jsx';
import ArticleContent89, { metadata as metadata89 } from './bills-broncos-divisional-round-2026.jsx';
import ArticleContent90, { metadata as metadata90 } from './maye-stroud-patriots-texans-playoff-ai-analysis.jsx';
import ArticleContent91, { metadata as metadata91 } from './caleb-williams-bears-packers-comeback-pitchmetric.jsx';
import ArticleContent92, { metadata as metadata92 } from './afc-championship-patriots-broncos-maye-nix-injury-2026.jsx';
import ArticleContent93, { metadata as metadata93 } from './stidham-broncos-patriots-afc-championship-2026.jsx';
import ArticleContent94, { metadata as metadata94 } from './broncos-patriots-afc-championship-2026.jsx';
import ArticleContent95, { metadata as metadata95 } from './broncos-patriots-afc-championship-injury-impact.jsx';
import ArticleContent96, { metadata as metadata96 } from './stidham-fumble-ponder-recovery-patriots-afc-championship-2026.jsx';
import ArticleContent97, { metadata as metadata97 } from './vrabel-patriots-super-bowl-turnaround.jsx';
import ArticleContent98, { metadata as metadata98 } from './super-bowl-lx-patriots-seahawks-rematch-betting.jsx';
import ArticleContent99, { metadata as metadata99 } from './super-bowl-lx-seahawks-patriots-rematch-betting-analysis.jsx';
import ArticleContent100, { metadata as metadata100 } from './seahawks-super-bowl-lxi-betting-favorites.jsx';
import ArticleContent101, { metadata as metadata101 } from './rams-seahawks-super-bowl-lxi-favorites-nfl-parity.jsx';
import ArticleContent102, { metadata as metadata102 } from './seahawks-super-bowl-lx-upset-pitchmetric-prediction.jsx';
import ArticleContent103, { metadata as metadata103 } from './chargers-cap-space-super-bowl-lxi-offensive-line-overhaul.jsx';
import ArticleContent104, { metadata as metadata104 } from './raiders-kubiak-mendoza-super-bowl-lxi-betting-angles.jsx';
import ArticleContent105, { metadata as metadata105 } from './falcons-kirk-cousins-release-nfl-era.jsx';
import ArticleContent106, { metadata as metadata106 } from './stafford-mvp-rams-super-bowl-lxi-contenders.jsx';
import ArticleContent107, { metadata as metadata107 } from './seahawks-super-bowl-lx-dynasty.jsx';
import ArticleContent108, { metadata as metadata108 } from './raiders-gm-maxx-crosby-trade-rumors-elite-2026.jsx';
import ArticleContent109, { metadata as metadata109 } from './colts-anthony-richardson-trade-permission-nfl-qb-market.jsx';
import ArticleContent110, { metadata as metadata110 } from './vikings-qb-market-murray-smith-tagovailoa-mccarthy.jsx';
import ArticleContent111, { metadata as metadata111 } from './cardinals-cut-kyler-murray-garoppolo-bridge-qb-nfl-betting.jsx';
import ArticleContent112, { metadata as metadata112 } from './dolphins-tua-willis-qb-overhaul-2026.jsx';
import ArticleContent113, { metadata as metadata113 } from './kyler-murray-vikings-nfc-north-betting-odds-2026.jsx';
import ArticleContent114, { metadata as metadata114 } from './raiders-draft-fernando-mendoza-betting-impact.jsx';
import ArticleContent115, { metadata as metadata115 } from './2026-nfl-draft-david-bailey-no3-pick-odds.jsx';
import ArticleContent116, { metadata as metadata116 } from './painters-mlb-debut-alonso-homer-pitchmetric-analysis.jsx';
import ArticleContent117, { metadata as metadata117 } from './avalanche-canucks-bednar-playoff-nhl-pitchmetric.jsx';
import ArticleContent118, { metadata as metadata118 } from './michigan-uconn-ncaa-championship-betting-ai-edge.jsx';
import ArticleContent119, { metadata as metadata119 } from './jokic-historic-triple-double-ai-prediction.jsx';
import ArticleContent120, { metadata as metadata120 } from './denver-michigan-frozen-four-upset-pitchmetric-ai.jsx';
import ArticleContent121, { metadata as metadata121 } from './lebron-james-nba-record-pitchmetric-ai-prediction.jsx';
import ArticleContent122, { metadata as metadata122 } from './eagles-wicks-trade-ai-prediction-pitchmetric.jsx';
import ArticleContent123, { metadata as metadata123 } from './arsenal-bournemouth-premier-league-title-race-analysis.jsx';
import ArticleContent124, { metadata as metadata124 } from './oklahoma-softball-no1-red-river-rivalry.jsx';
import ArticleContent125, { metadata as metadata125 } from './lamelo-ball-hornets-playoff-surge-ai-analysis.jsx';
import ArticleContent126, { metadata as metadata126 } from './deni-avdija-41-points-blazers-playoffs-ai-prediction.jsx';
import ArticleContent127, { metadata as metadata127 } from './stars-shootout-thriller-playoff-race-pitchmetric.jsx';
import ArticleContent128, { metadata as metadata128 } from './magic-dominate-hornets-pistons-playoff-showdown-ai-prediction.jsx';
import ArticleContent129, { metadata as metadata129 } from './nba-playoffs-2026-betting-edges-pitchmetric.jsx';
import ArticleContent130, { metadata as metadata130 } from './celtics-76ers-game1-ai-prediction.jsx';
import ArticleContent131, { metadata as metadata131 } from './nba-playoff-injuries-reshape-betting-2026.jsx';
import ArticleContent132, { metadata as metadata132 } from './ayo-dosunmu-43-point-bench-timberwolves-nuggets-playoffs.jsx';
import ArticleContent133, { metadata as metadata133 } from './nba-playoffs-2026-injury-crisis-betting-odds.jsx';
import ArticleContent134, { metadata as metadata134 } from './wembanyama-spurs-concussion-protocol-betting-analysis.jsx';
import ArticleContent135, { metadata as metadata135 } from './jokic-game-5-masterclass-nuggets-tie-wolves.jsx';
import ArticleContent136, { metadata as metadata136 } from './okc-thunder-sweep-suns-nba-playoffs-2026.jsx';
import ArticleContent137, { metadata as metadata137 } from './lebron-james-lakers-future-ai-analysis.jsx';
import ArticleContent138, { metadata as metadata138 } from './embiid-33-points-sixers-celtics-game-5-pitchmetric.jsx';
import ArticleContent139, { metadata as metadata139 } from './mahomes-torn-acl-chiefs-super-bowl-2026-betting-impact.jsx';
import ArticleContent140, { metadata as metadata140 } from './stephon-castle-spurs-bucks-playoff-elimination-2026.jsx';
import ArticleContent141, { metadata as metadata141 } from './sixers-celtics-game7-ai-prediction.jsx';
import ArticleContent142, { metadata as metadata142 } from './wnba-tip-off-2026-star-power-betting-edges.jsx';
import ArticleContent143, { metadata as metadata143 } from './thunder-holmgren-dominates-lakers-game-1-playoffs.jsx';
import ArticleContent144, { metadata as metadata144 } from './pistons-clinch-east-top-seed-nba-playoffs-detroit-dominance.jsx';
import ArticleContent145, { metadata as metadata145 } from './thunder-holmgren-dominates-lakers-playoffs-2026.jsx';
import ArticleContent146, { metadata as metadata146 } from './golden-knights-ducks-game-6-nhl-playoffs-2026.jsx';
import ArticleContent147, { metadata as metadata147 } from './knicks-tie-nba-playoff-3-point-record-sweep-76ers.jsx';

export const articles = [
  metadata0,
  metadata1,
  metadata2,
  metadata3,
  metadata4,
  metadata5,
  metadata6,
  metadata7,
  metadata8,
  metadata9,
  metadata10,
  metadata11,
  metadata12,
  metadata13,
  metadata14,
  metadata15,
  metadata16,
  metadata17,
  metadata18,
  metadata19,
  metadata20,
  metadata21,
  metadata22,
  metadata23,
  metadata24,
  metadata25,
  metadata26,
  metadata27,
  metadata28,
  metadata29,
  metadata30,
  metadata31,
  metadata32,
  metadata33,
  metadata34,
  metadata35,
  metadata36,
  metadata37,
  metadata38,
  metadata39,
  metadata40,
  metadata41,
  metadata42,
  metadata43,
  metadata44,
  metadata45,
  metadata46,
  metadata47,
  metadata48,
  metadata49,
  metadata50,
  metadata51,
  metadata52,
  metadata53,
  metadata54,
  metadata55,
  metadata56,
  metadata57,
  metadata58,
  metadata59,
  metadata60,
  metadata61,
  metadata62,
  metadata63,
  metadata64,
  metadata65,
  metadata66,
  metadata67,
  metadata68,
  metadata69,
  metadata70,
  metadata71,
  metadata72,
  metadata73,
  metadata74,
  metadata75,
  metadata76,
  metadata77,
  metadata78,
  metadata79,
  metadata80,
  metadata81,
  metadata82,
  metadata83,
  metadata84,
  metadata85,
  metadata86,
  metadata87,
  metadata88,
  metadata89,
  metadata90,
  metadata91,
  metadata92,
  metadata93,
  metadata94,
  metadata95,
  metadata96,
  metadata97,
  metadata98,
  metadata99,
  metadata100,
  metadata101,
  metadata102,
  metadata103,
  metadata104,
  metadata105,
  metadata106,
  metadata107,
  metadata108,
  metadata109,
  metadata110,
  metadata111,
  metadata112,
  metadata113,
  metadata114,
  metadata115,
  metadata116,
  metadata117,
  metadata118,
  metadata119,
  metadata120,
  metadata121,
  metadata122,
  metadata123,
  metadata124,
  metadata125,
  metadata126,
  metadata127,
  metadata128,
  metadata129,
  metadata130,
  metadata131,
  metadata132,
  metadata133,
  metadata134,
  metadata135,
  metadata136,
  metadata137,
  metadata138,
  metadata139,
  metadata140,
  metadata141,
  metadata142,
  metadata143,
  metadata144,
  metadata145,
  metadata146,
  metadata147
];

export const articleComponents = {
  [metadata0.slug]: ArticleContent0,
  [metadata1.slug]: ArticleContent1,
  [metadata2.slug]: ArticleContent2,
  [metadata3.slug]: ArticleContent3,
  [metadata4.slug]: ArticleContent4,
  [metadata5.slug]: ArticleContent5,
  [metadata6.slug]: ArticleContent6,
  [metadata7.slug]: ArticleContent7,
  [metadata8.slug]: ArticleContent8,
  [metadata9.slug]: ArticleContent9,
  [metadata10.slug]: ArticleContent10,
  [metadata11.slug]: ArticleContent11,
  [metadata12.slug]: ArticleContent12,
  [metadata13.slug]: ArticleContent13,
  [metadata14.slug]: ArticleContent14,
  [metadata15.slug]: ArticleContent15,
  [metadata16.slug]: ArticleContent16,
  [metadata17.slug]: ArticleContent17,
  [metadata18.slug]: ArticleContent18,
  [metadata19.slug]: ArticleContent19,
  [metadata20.slug]: ArticleContent20,
  [metadata21.slug]: ArticleContent21,
  [metadata22.slug]: ArticleContent22,
  [metadata23.slug]: ArticleContent23,
  [metadata24.slug]: ArticleContent24,
  [metadata25.slug]: ArticleContent25,
  [metadata26.slug]: ArticleContent26,
  [metadata27.slug]: ArticleContent27,
  [metadata28.slug]: ArticleContent28,
  [metadata29.slug]: ArticleContent29,
  [metadata30.slug]: ArticleContent30,
  [metadata31.slug]: ArticleContent31,
  [metadata32.slug]: ArticleContent32,
  [metadata33.slug]: ArticleContent33,
  [metadata34.slug]: ArticleContent34,
  [metadata35.slug]: ArticleContent35,
  [metadata36.slug]: ArticleContent36,
  [metadata37.slug]: ArticleContent37,
  [metadata38.slug]: ArticleContent38,
  [metadata39.slug]: ArticleContent39,
  [metadata40.slug]: ArticleContent40,
  [metadata41.slug]: ArticleContent41,
  [metadata42.slug]: ArticleContent42,
  [metadata43.slug]: ArticleContent43,
  [metadata44.slug]: ArticleContent44,
  [metadata45.slug]: ArticleContent45,
  [metadata46.slug]: ArticleContent46,
  [metadata47.slug]: ArticleContent47,
  [metadata48.slug]: ArticleContent48,
  [metadata49.slug]: ArticleContent49,
  [metadata50.slug]: ArticleContent50,
  [metadata51.slug]: ArticleContent51,
  [metadata52.slug]: ArticleContent52,
  [metadata53.slug]: ArticleContent53,
  [metadata54.slug]: ArticleContent54,
  [metadata55.slug]: ArticleContent55,
  [metadata56.slug]: ArticleContent56,
  [metadata57.slug]: ArticleContent57,
  [metadata58.slug]: ArticleContent58,
  [metadata59.slug]: ArticleContent59,
  [metadata60.slug]: ArticleContent60,
  [metadata61.slug]: ArticleContent61,
  [metadata62.slug]: ArticleContent62,
  [metadata63.slug]: ArticleContent63,
  [metadata64.slug]: ArticleContent64,
  [metadata65.slug]: ArticleContent65,
  [metadata66.slug]: ArticleContent66,
  [metadata67.slug]: ArticleContent67,
  [metadata68.slug]: ArticleContent68,
  [metadata69.slug]: ArticleContent69,
  [metadata70.slug]: ArticleContent70,
  [metadata71.slug]: ArticleContent71,
  [metadata72.slug]: ArticleContent72,
  [metadata73.slug]: ArticleContent73,
  [metadata74.slug]: ArticleContent74,
  [metadata75.slug]: ArticleContent75,
  [metadata76.slug]: ArticleContent76,
  [metadata77.slug]: ArticleContent77,
  [metadata78.slug]: ArticleContent78,
  [metadata79.slug]: ArticleContent79,
  [metadata80.slug]: ArticleContent80,
  [metadata81.slug]: ArticleContent81,
  [metadata82.slug]: ArticleContent82,
  [metadata83.slug]: ArticleContent83,
  [metadata84.slug]: ArticleContent84,
  [metadata85.slug]: ArticleContent85,
  [metadata86.slug]: ArticleContent86,
  [metadata87.slug]: ArticleContent87,
  [metadata88.slug]: ArticleContent88,
  [metadata89.slug]: ArticleContent89,
  [metadata90.slug]: ArticleContent90,
  [metadata91.slug]: ArticleContent91,
  [metadata92.slug]: ArticleContent92,
  [metadata93.slug]: ArticleContent93,
  [metadata94.slug]: ArticleContent94,
  [metadata95.slug]: ArticleContent95,
  [metadata96.slug]: ArticleContent96,
  [metadata97.slug]: ArticleContent97,
  [metadata98.slug]: ArticleContent98,
  [metadata99.slug]: ArticleContent99,
  [metadata100.slug]: ArticleContent100,
  [metadata101.slug]: ArticleContent101,
  [metadata102.slug]: ArticleContent102,
  [metadata103.slug]: ArticleContent103,
  [metadata104.slug]: ArticleContent104,
  [metadata105.slug]: ArticleContent105,
  [metadata106.slug]: ArticleContent106,
  [metadata107.slug]: ArticleContent107,
  [metadata108.slug]: ArticleContent108,
  [metadata109.slug]: ArticleContent109,
  [metadata110.slug]: ArticleContent110,
  [metadata111.slug]: ArticleContent111,
  [metadata112.slug]: ArticleContent112,
  [metadata113.slug]: ArticleContent113,
  [metadata114.slug]: ArticleContent114,
  [metadata115.slug]: ArticleContent115,
  [metadata116.slug]: ArticleContent116,
  [metadata117.slug]: ArticleContent117,
  [metadata118.slug]: ArticleContent118,
  [metadata119.slug]: ArticleContent119,
  [metadata120.slug]: ArticleContent120,
  [metadata121.slug]: ArticleContent121,
  [metadata122.slug]: ArticleContent122,
  [metadata123.slug]: ArticleContent123,
  [metadata124.slug]: ArticleContent124,
  [metadata125.slug]: ArticleContent125,
  [metadata126.slug]: ArticleContent126,
  [metadata127.slug]: ArticleContent127,
  [metadata128.slug]: ArticleContent128,
  [metadata129.slug]: ArticleContent129,
  [metadata130.slug]: ArticleContent130,
  [metadata131.slug]: ArticleContent131,
  [metadata132.slug]: ArticleContent132,
  [metadata133.slug]: ArticleContent133,
  [metadata134.slug]: ArticleContent134,
  [metadata135.slug]: ArticleContent135,
  [metadata136.slug]: ArticleContent136,
  [metadata137.slug]: ArticleContent137,
  [metadata138.slug]: ArticleContent138,
  [metadata139.slug]: ArticleContent139,
  [metadata140.slug]: ArticleContent140,
  [metadata141.slug]: ArticleContent141,
  [metadata142.slug]: ArticleContent142,
  [metadata143.slug]: ArticleContent143,
  [metadata144.slug]: ArticleContent144,
  [metadata145.slug]: ArticleContent145,
  [metadata146.slug]: ArticleContent146,
  [metadata147.slug]: ArticleContent147
};

export function getArticleBySlug(slug) {
  return articles.find((article) => article.slug === slug);
}

export function getArticleComponent(slug) {
  return articleComponents[slug];
}

export function getAllArticleSlugs() {
  return articles.map((article) => article.slug);
}
